module.exports = __webpack_public_path__ + "static/lineto-circular-book-db4b80bf1be2ab7715903c624e6d21ed.woff";